import { render, staticRenderFns } from "./SettingsMnemonicDeleted.vue?vue&type=template&id=b8e9bd9a"
import script from "./SettingsMnemonicDeleted.vue?vue&type=script&lang=js"
export * from "./SettingsMnemonicDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports